import { render, staticRenderFns } from "./TaskEditDialog.vue?vue&type=template&id=db46f240&"
import script from "./TaskEditDialog.vue?vue&type=script&lang=js&"
export * from "./TaskEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports